function fallbackCopyTextToClipboard(text) {
    let textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();


    return new Promise((resolve, reject) => {
        try {
            let successful = document.execCommand('copy');
            let msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
            if (successful) resolve(successful); else reject(successful);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
            reject(err);
        }

        document.body.removeChild(textArea);
    });
}

export function copyTextToClipboard(text) {
    let result;
    if (!navigator.clipboard) {
        return fallbackCopyTextToClipboard(text);
    }
    result = navigator.clipboard.writeText(text)
    result.then(function () {
        console.log('Async: Copying to clipboard was successful!');
    }, function (err) {
        console.error('Async: Could not copy text: ', err);
    });
    return result;
}

// refs: https://stackoverflow.com/q/400212
//
// var copyBobBtn = document.querySelector('.js-copy-bob-btn'),
//     copyJaneBtn = document.querySelector('.js-copy-jane-btn');
//
// copyBobBtn.addEventListener('click', function(event) {
//     copyTextToClipboard('Bob');
// });
//
//
// copyJaneBtn.addEventListener('click', function(event) {
//     copyTextToClipboard('Jane');
// });
// <div style="display:inline-block; vertical-align:top;">
//     <button class="js-copy-bob-btn">Set clipboard to BOB</button><br /><br />
//     <button class="js-copy-jane-btn">Set clipboard to JANE</button>
// </div>
// <div style="display:inline-block;">
//   <textarea class="js-test-textarea" cols="35" rows="4">Try pasting into here to see what you have on your clipboard:
//
//   </textarea>
// </div>
